import * as React from 'react';
import { connect } from 'react-redux';
import swal from 'bootstrap-sweetalert';

interface IAlertCallbacks {
    confirmCallback: Function;
    cancelCallback: Function;
}

export interface ISweetAlertProps {
    params?: Object & IAlertCallbacks;
    type?: string;
    autoClose?: number;
}

export class SweetAlertImpl extends React.PureComponent<ISweetAlertProps, {}> {
    constructor(props: ISweetAlertProps) {
        super(props);
    }

    public render() {
        const { params, type, autoClose } = this.props;
        if (params && type) {
            swal({
                ...params, timer: autoClose
            }, (isConfirm) => {
                if (isConfirm) {
                    if (params.confirmCallback) {
                        params.confirmCallback();
                    }
                } else {
                    if (params.cancelCallback) {
                        params.cancelCallback();
                    }
                }
            });
        }
        return <div></div>;
    }

}
export function mapStateToProps(state) {
    return {
        params: state.miscellaneous.get('alert'),
        type: state.miscellaneous.get('alertType'),
        autoClose: state.miscellaneous.get('autoClose')
    };
}
export const SweetAlert = connect<{}, {}, ISweetAlertProps>(mapStateToProps)(SweetAlertImpl);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/reusableComponents/SweetAlert.tsx